<ng-container [formGroup]="formGroup">
    <div [class]="theme() === 'auth' ? 'space-y-4' : 'mb-6 space-y-4'">
        @if (theme() !== 'auth') {
            <h4 class="mb-4 text-base font-semibold text-[#0d1912]">
                User Information
            </h4>
        }

        <!-- First & Last Name Row -->
        <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div class="space-y-1.5">
                <label
                    for="firstName"
                    class="block font-medium"
                    [class]="
                        theme() === 'auth'
                            ? 'text-xs font-semibold tracking-wide text-slate-700 uppercase'
                            : 'mb-1 text-sm text-[#0d1912]'
                    "
                >
                    First Name <span class="text-red-500">*</span>
                </label>
                <div class="relative flex items-center">
                    @if (theme() === 'auth') {
                        <span
                            class="pointer-events-none absolute top-3 left-3.5 text-slate-400"
                        >
                            <ng-icon name="lucideUser" class="h-4.5 w-4.5" />
                        </span>
                    }
                    <input
                        id="firstName"
                        type="text"
                        placeholder="John"
                        formControlName="firstName"
                        autocomplete="given-name"
                        class="w-full transition-all outline-none"
                        [class]="
                            theme() === 'auth'
                                ? 'rounded-xl border border-slate-200 bg-slate-50/70 py-2.5 pr-3 pl-10 text-sm text-slate-900 placeholder:text-slate-400 hover:border-slate-300 focus:border-[#1587e8] focus:bg-white focus:ring-4 focus:ring-[#1587e8]/10'
                                : 'rounded-lg border border-[#e5e1d5] px-3 py-2 text-sm focus:border-[#be9a46] focus:ring-2 focus:ring-[#be9a46]/20'
                        "
                    />
                </div>
                @if (
                    formGroup.get('firstName')?.invalid &&
                    formGroup.get('firstName')?.touched
                ) {
                    <p
                        class="text-xs font-medium"
                        [class]="
                            theme() === 'auth'
                                ? 'text-red-600'
                                : 'mt-1 text-red-500'
                        "
                    >
                        First name is required
                    </p>
                }
            </div>

            <div class="space-y-1.5">
                <label
                    for="lastName"
                    class="block font-medium"
                    [class]="
                        theme() === 'auth'
                            ? 'text-xs font-semibold tracking-wide text-slate-700 uppercase'
                            : 'mb-1 text-sm text-[#0d1912]'
                    "
                >
                    Last Name <span class="text-red-500">*</span>
                </label>
                <div class="relative flex items-center">
                    @if (theme() === 'auth') {
                        <span
                            class="pointer-events-none absolute top-3 left-3.5 text-slate-400"
                        >
                            <ng-icon name="lucideUser" class="h-4.5 w-4.5" />
                        </span>
                    }
                    <input
                        id="lastName"
                        type="text"
                        placeholder="Doe"
                        formControlName="lastName"
                        autocomplete="family-name"
                        class="w-full transition-all outline-none"
                        [class]="
                            theme() === 'auth'
                                ? 'rounded-xl border border-slate-200 bg-slate-50/70 py-2.5 pr-3 pl-10 text-sm text-slate-900 placeholder:text-slate-400 hover:border-slate-300 focus:border-[#1587e8] focus:bg-white focus:ring-4 focus:ring-[#1587e8]/10'
                                : 'rounded-lg border border-[#e5e1d5] px-3 py-2 text-sm focus:border-[#be9a46] focus:ring-2 focus:ring-[#be9a46]/20'
                        "
                    />
                </div>
                @if (
                    formGroup.get('lastName')?.invalid &&
                    formGroup.get('lastName')?.touched
                ) {
                    <p
                        class="text-xs font-medium"
                        [class]="
                            theme() === 'auth'
                                ? 'text-red-600'
                                : 'mt-1 text-red-500'
                        "
                    >
                        Last name is required
                    </p>
                }
            </div>
        </div>

        <!-- Email Address -->
        <div class="space-y-1.5">
            <label
                for="reg-email"
                class="block font-medium"
                [class]="
                    theme() === 'auth'
                        ? 'text-xs font-semibold tracking-wide text-slate-700 uppercase'
                        : 'mb-1 text-sm text-[#0d1912]'
                "
            >
                Email <span class="text-red-500">*</span>
            </label>
            <div class="relative flex items-center">
                @if (theme() === 'auth') {
                    <span
                        class="pointer-events-none absolute top-3 left-3.5 text-slate-400"
                    >
                        <ng-icon name="lucideMail" class="h-4.5 w-4.5" />
                    </span>
                }
                <input
                    id="reg-email"
                    type="email"
                    placeholder="name@company.com"
                    formControlName="email"
                    autocomplete="email"
                    class="w-full transition-all outline-none"
                    [class]="
                        theme() === 'auth'
                            ? 'rounded-xl border border-slate-200 bg-slate-50/70 py-2.5 pr-3 pl-10 text-sm text-slate-900 placeholder:text-slate-400 hover:border-slate-300 focus:border-[#1587e8] focus:bg-white focus:ring-4 focus:ring-[#1587e8]/10'
                            : 'rounded-lg border border-[#e5e1d5] px-3 py-2 text-sm focus:border-[#be9a46] focus:ring-2 focus:ring-[#be9a46]/20'
                    "
                />
            </div>
            @if (
                formGroup.get('email')?.invalid &&
                formGroup.get('email')?.touched
            ) {
                <p
                    class="text-xs font-medium"
                    [class]="
                        theme() === 'auth'
                            ? 'text-red-600'
                            : 'mt-1 text-red-500'
                    "
                >
                    Valid email is required
                </p>
            }
        </div>

        <!-- Phone Number (Optional) -->
        <div class="space-y-1.5">
            <label
                for="phone"
                class="block font-medium"
                [class]="
                    theme() === 'auth'
                        ? 'text-xs font-semibold tracking-wide text-slate-700 uppercase'
                        : 'mb-1 text-sm text-[#0d1912]'
                "
            >
                Phone Number
                <span
                    [class]="
                        theme() === 'auth'
                            ? 'text-xs font-normal text-slate-400 lowercase'
                            : 'text-slate-400'
                    "
                    >(optional)</span
                >
            </label>
            <div class="relative flex items-center">
                @if (theme() === 'auth') {
                    <span
                        class="pointer-events-none absolute top-3 left-3.5 text-slate-400"
                    >
                        <ng-icon name="lucidePhone" class="h-4.5 w-4.5" />
                    </span>
                }
                <input
                    id="phone"
                    type="tel"
                    placeholder="+880 1XXX-XXXXXX"
                    formControlName="phone"
                    autocomplete="tel"
                    class="w-full transition-all outline-none"
                    [class]="
                        theme() === 'auth'
                            ? 'rounded-xl border border-slate-200 bg-slate-50/70 py-2.5 pr-3 pl-10 text-sm text-slate-900 placeholder:text-slate-400 hover:border-slate-300 focus:border-[#1587e8] focus:bg-white focus:ring-4 focus:ring-[#1587e8]/10'
                            : 'rounded-lg border border-[#e5e1d5] px-3 py-2 text-sm focus:border-[#be9a46] focus:ring-2 focus:ring-[#be9a46]/20'
                    "
                />
            </div>
        </div>

        <!-- Password Field -->
        <div class="space-y-1.5">
            <label
                for="reg-password"
                class="block font-medium"
                [class]="
                    theme() === 'auth'
                        ? 'text-xs font-semibold tracking-wide text-slate-700 uppercase'
                        : 'mb-1 text-sm text-[#0d1912]'
                "
            >
                Password <span class="text-red-500">*</span>
            </label>
            <div class="relative flex items-center">
                @if (theme() === 'auth') {
                    <span
                        class="pointer-events-none absolute top-3 left-3.5 text-slate-400"
                    >
                        <ng-icon name="lucideLock" class="h-4.5 w-4.5" />
                    </span>
                }
                <input
                    id="reg-password"
                    [type]="passwordInputType()"
                    placeholder="Enter password"
                    formControlName="password"
                    autocomplete="new-password"
                    class="w-full transition-all outline-none"
                    [class]="
                        theme() === 'auth'
                            ? 'rounded-xl border border-slate-200 bg-slate-50/70 py-2.5 pr-11 pl-10 text-sm text-slate-900 placeholder:text-slate-400 hover:border-slate-300 focus:border-[#1587e8] focus:bg-white focus:ring-4 focus:ring-[#1587e8]/10'
                            : 'rounded-lg border border-[#e5e1d5] px-3 py-2 pr-10 text-sm focus:border-[#be9a46] focus:ring-2 focus:ring-[#be9a46]/20'
                    "
                />
                <button
                    type="button"
                    (click)="togglePasswordVisibility()"
                    [disabled]="disabled()"
                    [class]="
                        theme() === 'auth'
                            ? 'absolute right-2.5 flex h-8 w-8 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 focus:outline-none'
                            : 'absolute top-1/2 right-3 -translate-y-1/2 text-slate-500 hover:text-[#0d1912]'
                    "
                    [title]="
                        passwordVisible() ? 'Hide password' : 'Show password'
                    "
                >
                    <ng-icon [name]="passwordIcon()" class="h-4 w-4" />
                    <span class="sr-only">Toggle password visibility</span>
                </button>
            </div>

            <!-- Password Requirements Checklist (Dialog Theme) -->
            @if (theme() !== 'auth' && formGroup.get('password')?.touched) {
                <div class="mt-2 space-y-1">
                    <div class="flex items-center gap-2 text-xs">
                        <ng-icon
                            [name]="hasMinLength ? 'lucideCheck' : 'lucideX'"
                            [class]="
                                hasMinLength ? 'text-green-500' : 'text-red-500'
                            "
                            class="h-3 w-3"
                        />
                        <span
                            [class]="
                                hasMinLength ? 'text-green-600' : 'text-red-600'
                            "
                        >
                            At least 8 characters
                        </span>
                    </div>
                    <div class="flex items-center gap-2 text-xs">
                        <ng-icon
                            [name]="hasUpper ? 'lucideCheck' : 'lucideX'"
                            [class]="
                                hasUpper ? 'text-green-500' : 'text-red-500'
                            "
                            class="h-3 w-3"
                        />
                        <span
                            [class]="
                                hasUpper ? 'text-green-600' : 'text-red-600'
                            "
                        >
                            One uppercase letter
                        </span>
                    </div>
                    <div class="flex items-center gap-2 text-xs">
                        <ng-icon
                            [name]="hasLower ? 'lucideCheck' : 'lucideX'"
                            [class]="
                                hasLower ? 'text-green-500' : 'text-red-500'
                            "
                            class="h-3 w-3"
                        />
                        <span
                            [class]="
                                hasLower ? 'text-green-600' : 'text-red-600'
                            "
                        >
                            One lowercase letter
                        </span>
                    </div>
                    <div class="flex items-center gap-2 text-xs">
                        <ng-icon
                            [name]="
                                hasNumber(passwordValue)
                                    ? 'lucideCheck'
                                    : 'lucideX'
                            "
                            [class]="
                                hasNumber(passwordValue)
                                    ? 'text-green-500'
                                    : 'text-red-500'
                            "
                            class="h-3 w-3"
                        />
                        <span
                            [class]="
                                hasNumber(passwordValue)
                                    ? 'text-green-600'
                                    : 'text-red-600'
                            "
                        >
                            One number
                        </span>
                    </div>
                    <div class="flex items-center gap-2 text-xs">
                        <ng-icon
                            [name]="
                                hasSpecialChar(passwordValue)
                                    ? 'lucideCheck'
                                    : 'lucideX'
                            "
                            [class]="
                                hasSpecialChar(passwordValue)
                                    ? 'text-green-500'
                                    : 'text-red-500'
                            "
                            class="h-3 w-3"
                        />
                        <span
                            [class]="
                                hasSpecialChar(passwordValue)
                                    ? 'text-green-600'
                                    : 'text-red-600'
                            "
                        >
                            One special character (!&#64;#$%^&*)
                        </span>
                    </div>
                </div>
            }

            <!-- Interactive Password Strength Meter (Auth Theme) -->
            @if (theme() === 'auth' && passwordValue) {
                <div class="space-y-2 pt-1.5">
                    <div class="flex items-center justify-between text-xs">
                        <span class="font-medium text-slate-500"
                            >Password Strength</span
                        >
                        <span
                            class="font-bold"
                            [ngClass]="{
                                'text-rose-500': strengthScore <= 1,
                                'text-amber-500': strengthScore === 2,
                                'text-blue-500': strengthScore === 3,
                                'text-emerald-600': strengthScore === 4,
                            }"
                        >
                            {{ strengthLabel }}
                        </span>
                    </div>

                    <div class="grid grid-cols-4 gap-1.5">
                        <div
                            class="h-1.5 rounded-full transition-colors duration-300"
                            [ngClass]="
                                strengthScore >= 1
                                    ? strengthColorClass
                                    : 'bg-slate-200'
                            "
                        ></div>
                        <div
                            class="h-1.5 rounded-full transition-colors duration-300"
                            [ngClass]="
                                strengthScore >= 2
                                    ? strengthColorClass
                                    : 'bg-slate-200'
                            "
                        ></div>
                        <div
                            class="h-1.5 rounded-full transition-colors duration-300"
                            [ngClass]="
                                strengthScore >= 3
                                    ? strengthColorClass
                                    : 'bg-slate-200'
                            "
                        ></div>
                        <div
                            class="h-1.5 rounded-full transition-colors duration-300"
                            [ngClass]="
                                strengthScore >= 4
                                    ? strengthColorClass
                                    : 'bg-slate-200'
                            "
                        ></div>
                    </div>

                    <!-- Password Requirements Checklist -->
                    <div
                        class="grid grid-cols-1 gap-1.5 pt-1 text-[11px] sm:grid-cols-2"
                    >
                        <div
                            class="flex items-center gap-1.5"
                            [ngClass]="
                                hasMinLength
                                    ? 'text-emerald-600'
                                    : 'text-slate-400'
                            "
                        >
                            <ng-icon
                                name="lucideCheck"
                                class="h-3.5 w-3.5 shrink-0"
                                [ngClass]="
                                    hasMinLength
                                        ? 'text-emerald-500'
                                        : 'text-slate-300'
                                "
                            />
                            <span>At least 8 characters</span>
                        </div>

                        <div
                            class="flex items-center gap-1.5"
                            [ngClass]="
                                hasLower && hasUpper
                                    ? 'text-emerald-600'
                                    : 'text-slate-400'
                            "
                        >
                            <ng-icon
                                name="lucideCheck"
                                class="h-3.5 w-3.5 shrink-0"
                                [ngClass]="
                                    hasLower && hasUpper
                                        ? 'text-emerald-500'
                                        : 'text-slate-300'
                                "
                            />
                            <span>Upper & lower case</span>
                        </div>

                        <div
                            class="flex items-center gap-1.5"
                            [ngClass]="
                                hasNumber(passwordValue)
                                    ? 'text-emerald-600'
                                    : 'text-slate-400'
                            "
                        >
                            <ng-icon
                                name="lucideCheck"
                                class="h-3.5 w-3.5 shrink-0"
                                [ngClass]="
                                    hasNumber(passwordValue)
                                        ? 'text-emerald-500'
                                        : 'text-slate-300'
                                "
                            />
                            <span>At least 1 number (0-9)</span>
                        </div>

                        <div
                            class="flex items-center gap-1.5"
                            [ngClass]="
                                hasSpecialChar(passwordValue)
                                    ? 'text-emerald-600'
                                    : 'text-slate-400'
                            "
                        >
                            <ng-icon
                                name="lucideCheck"
                                class="h-3.5 w-3.5 shrink-0"
                                [ngClass]="
                                    hasSpecialChar(passwordValue)
                                        ? 'text-emerald-500'
                                        : 'text-slate-300'
                                "
                            />
                            <span>Special character (!&#64;#$%^&*)</span>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</ng-container>
